import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import {SharedModule} from "../../../shared/shared.module";
import {NavbarItemComponent} from "../navbar-item/navbar-item.component";
import {LanguageSelectorComponent} from "../../default/language-selector/language-selector.component";
import {AuthenticationService} from "../../../services/authentication.service";

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [SharedModule, NavbarItemComponent, LanguageSelectorComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
  environment = environment.environment;

  constructor(private authenticationService: AuthenticationService) {
  }

  logout() {
    this.authenticationService.logout();
  }
}
